export default "__VITE_ASSET__Q8CCgceS__"